var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "background-color": "white", padding: "2em" } },
    [
      _c("h3", [_vm._v("1 全概率公式")]),
      _vm._v(" "),
      _c("img", { attrs: { src: _vm.bayes_PB } }),
      _vm._v(" "),
      _c("p", [_vm._v("A为分类；")]),
      _vm._v(" "),
      _c("p", [_vm._v("B为特征；")]),
      _vm._v(" "),
      _c("p", [_vm._v("P(A_i) :第i个分类占比，所有分类占比总和为1；")]),
      _vm._v(" "),
      _c("p", [_vm._v("P(B|A_i )：第i个分类的某特征概率，条件概率；")]),
      _vm._v(" "),
      _c("p", [_vm._v("P(B): 所有分类的某特征的总概率；")]),
      _vm._v(" "),
      _c("h3", [_vm._v("2 贝叶斯公式")]),
      _vm._v(" "),
      _c("img", { attrs: { src: _vm.bayes_equation } }),
      _vm._v(" "),
      _c("p", [_vm._v("P(A):先验概率")]),
      _vm._v(" "),
      _c("p", [_vm._v("P(B|A):条件概率")]),
      _vm._v(" "),
      _c("p", [_vm._v("P(B):特征全概率")]),
      _vm._v(" "),
      _c("p", [_vm._v("P(A|B):后验概率")]),
      _vm._v(" "),
      _c("img", { attrs: { src: _vm.bayes_equation2 } }),
      _vm._v(" "),
      _c("h3", [_vm._v("3 贝叶斯分类器(多分类单特征)")]),
      _vm._v(" "),
      _c("img", { attrs: { src: _vm.bayes_equation3 } }),
      _vm._v(" "),
      _c("h3", [_vm._v("4 贝叶斯分类器(多分类多特征)")]),
      _vm._v(" "),
      _c("img", { attrs: { src: _vm.bayes_equation4 } }),
      _vm._v(" "),
      _c("h3", [_vm._v("5 拉普拉斯优化")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当因样本量过小，P(Bi|Aj)特征出现的概率统计值为0时，可做如下优化："
        )
      ]),
      _vm._v(" "),
      _c("img", { attrs: { src: _vm.bayes_equation5 } }),
      _vm._v(" "),
      _c("p", [_vm._v("N 总样本数 ")]),
      _vm._v(" "),
      _c("p", [_vm._v("N(A) 类别数")]),
      _vm._v(" "),
      _c("p", [_vm._v("N(Aj) 类别Aj的样本数")]),
      _vm._v(" "),
      _c("p", [_vm._v("N(Bi|Aj) 类别Aj中属性Bi出现的次数")]),
      _vm._v(" "),
      _c("p", [_vm._v("N(Bi) 属性Bi可能取值的个数")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }